@switch (type()) {
  @case ('spinnerIndeterminate') {
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  }
  @case ('spinnerDeterminate') {
    <mat-progress-spinner mode="determinate" [value]="progress()"></mat-progress-spinner>
  }
  @case ('progressbarIndeterminate') {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @case ('progressbarDeterminate') {
    <mat-progress-bar mode="determinate" [value]=""></mat-progress-bar>
  }
  @case ('progressbarBuffer') {
    <mat-progress-bar mode="buffer" [value]="progress()" [bufferValue]="bufferProgress()"></mat-progress-bar>
  }
}
